/**
 * Isopure animations + Cuberto-style smooth scroll (Lenis)
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EXCLUDED = ['shopify-section--header', 'shopify-section--announcement-bar', 'shopify-section--footer'];

  var sectionObserver = null;
  var gridObserver = null;
  var lenis = null;

  function isExcluded(el) {
    return EXCLUDED.some(function (cls) {
      return el.classList.contains(cls);
    });
  }

  function getScrollProgress(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight;
    var start = vh * 0.9;
    var end = vh * 0.42;
    return Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
  }

  function wrapRevealLine(el, lineOffset) {
    if (el.dataset.isoReveal) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.textContent = '';
    el.classList.add('iso-reveal-line');
    el.dataset.isoReveal = 'true';
    if (lineOffset) {
      el.style.setProperty('--iso-line-offset', lineOffset);
    }

    text.split(' ').forEach(function (word, i, arr) {
      var wordEl = document.createElement('span');
      wordEl.className = 'iso-reveal-word';

      var mask = document.createElement('span');
      mask.className = 'iso-reveal-word__mask';

      var inner = document.createElement('span');
      inner.className = 'iso-reveal-word__inner';
      inner.textContent = word;

      mask.appendChild(inner);
      wordEl.appendChild(mask);
      el.appendChild(wordEl);

      if (i < arr.length - 1) {
        el.appendChild(document.createTextNode(' '));
      }
    });
  }

  function prepareRevealText(section) {
    section.querySelectorAll('.eveything-text h3').forEach(function (el, index) {
      wrapRevealLine(el, (index * 0.12).toFixed(2));
    });

    section.querySelectorAll('.section-header h2.h2, .section-header h1.h1, .section-header h3.h3').forEach(function (el) {
      if (el.classList.contains('iso-static-heading') || el.closest('.iso-static-heading')) return;
      el.classList.add('iso-reveal-heading');
      wrapRevealLine(el, 0);
    });

    section.querySelectorAll('.nutrition-section .heading h3').forEach(function (el) {
      wrapRevealLine(el, 0);
    });
  }

  function lineProgress(el) {
    var offset = parseFloat(el.style.getPropertyValue('--iso-line-offset') || '0');
    var raw = getScrollProgress(el);
    if (offset > 0) {
      raw = (raw - offset) / (1 - offset);
    }
    return Math.max(0, Math.min(1, raw));
  }

  function updateRevealLines() {
    document.querySelectorAll('.iso-reveal-line').forEach(function (el) {
      var progress = lineProgress(el);
      var words = el.querySelectorAll('.iso-reveal-word');
      var count = words.length;

    words.forEach(function (word, i) {
  var isEverythingSection = el.closest('.everything-home-section');
  var staggerSpread = isEverythingSection ? 0.28 : 0.55;
  var staggerDelay = isEverythingSection ? 0.18 : 0.35;
  var progressWindow = isEverythingSection ? 0.82 : 0.65;
  var stagger = count > 1 ? (i / (count - 1)) * staggerSpread : 0;
  var wordProgress = (progress - stagger * staggerDelay) / progressWindow;
  wordProgress = Math.max(0, Math.min(1, wordProgress));
  word.style.setProperty('--iso-word-progress', wordProgress.toFixed(4));
});
    });
  }

  function updateBannerScroll() {
    document.querySelectorAll('.iso-scroll-banner').forEach(function (banner) {
      var section = banner.closest('.shopify-section');
      if (!section) return;

      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;

      if (rect.bottom < 0 || rect.top > vh * 1.15) {
        banner.style.removeProperty('--iso-banner-y');
        banner.style.removeProperty('--iso-banner-scale');
        return;
      }

      var scrollIn = Math.max(0, Math.min(1, 1 - rect.top / vh));
      var y = Math.max(-48, Math.min(48, rect.top * 0.1));
      var scale = 1 + (1 - scrollIn) * 0.04;

      banner.style.setProperty('--iso-banner-y', y.toFixed(2) + 'px');
      banner.style.setProperty('--iso-banner-scale', scale.toFixed(4));
    });
  }

  function prepareSection(section) {
    if (isExcluded(section) || section.dataset.isoReady) return;
    section.dataset.isoReady = 'true';

    prepareRevealText(section);

    if (section.classList.contains('shopify-section--video')) {
      var banner = section.querySelector('.content-over-media');
      if (banner) banner.classList.add('iso-scroll-banner');
    }

    if (section.querySelector('media-grid.collection-for-desktop, .mix-shake-section')) return;

    section.classList.add('iso-animate-section');

    section.querySelectorAll('.nutrition-grid .item').forEach(function (item, index) {
      item.classList.add('iso-animate-box');
      item.style.setProperty('--iso-delay', (0.1 + index * 0.09).toFixed(2) + 's');
    });

    var nutritionHeading = section.querySelector('.nutrition-section .heading');
    if (nutritionHeading) nutritionHeading.classList.add('iso-nutrition-heading');

    section.querySelectorAll(
      '.section-header, .prose > *, .text-with-icons__item, .media-with-text, .button, .section-stack > *'
    ).forEach(function (el, index) {
      if (el.closest('.eveything-text, .nutrition-grid, .iso-reveal-line')) return;
      if (el.classList.contains('iso-static-heading') || el.closest('.iso-static-heading')) return;
      if (el.matches('.section-header') && el.querySelector('.iso-reveal-line')) return;
      if (el.closest('reveal-items, slideshow-carousel')) return;
      if (el.hasAttribute('reveal-on-scroll')) return;
      el.classList.add('iso-animate-el');
      el.style.setProperty('--iso-delay', Math.min(index * 0.05, 0.28).toFixed(2) + 's');
    });
  }

  function revealGrid(grid) {
    if (!grid || grid.classList.contains('is-grid-revealed')) return;
    grid.classList.add('is-grid-revealed');
    var heading = grid.closest('.nutrition-section');
    if (heading) {
      heading = heading.querySelector('.iso-nutrition-heading');
      if (heading) heading.classList.add('is-heading-revealed');
    }
    if (gridObserver) gridObserver.unobserve(grid);
  }

  function revealSection(section) {
    if (!section || section.classList.contains('is-revealed')) return;
    section.classList.add('is-revealed');
    if (sectionObserver) sectionObserver.unobserve(section);
  }

  function isInZone(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight;
    return rect.top < vh * 0.85 && rect.bottom > vh * 0.12;
  }

  function scanAll() {
    document.querySelectorAll('.nutrition-grid:not(.is-grid-revealed)').forEach(function (grid) {
      if (isInZone(grid)) revealGrid(grid);
    });
    document.querySelectorAll('.iso-animate-section:not(.is-revealed)').forEach(function (section) {
      if (isInZone(section)) revealSection(section);
    });
    updateRevealLines();
    updateBannerScroll();
  }

  function initLenis() {
    if (typeof Lenis === 'undefined') return;

    // Smart Wishlist /a/wishlist relies on normal scroll + Bootstrap modals
    if (
      document.body.classList.contains('wishlistpage') ||
      document.querySelector('.wishlistbodycontainer, .wishlistpage') ||
      /\/a\/wishlist/i.test(window.location.pathname)
    ) {
      document.documentElement.classList.add('wishlist-page-active');
      return;
    }

    document.documentElement.classList.add('lenis');

    lenis = new Lenis({
      lerp: 0.09,
      smoothWheel: true,
      wheelMultiplier: 0.95,
      touchMultiplier: 1.1
    });

    window.isopureLenis = lenis;

    lenis.on('scroll', function () {
      scanAll();
      document.dispatchEvent(new CustomEvent('isopure:scroll'));
      window.dispatchEvent(new Event('scroll'));
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  function initObservers() {
    sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) revealSection(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -2% 0px', threshold: 0.04 }
    );

    gridObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) revealGrid(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.2 }
    );
  }

  function init() {
    document.documentElement.classList.add('iso-anim-enabled');

    document.querySelectorAll('main .shopify-section').forEach(prepareSection);
    initObservers();

    document.querySelectorAll('.nutrition-grid').forEach(function (grid) {
      if (isInZone(grid)) revealGrid(grid);
      else gridObserver.observe(grid);
    });

    document.querySelectorAll('.iso-animate-section:not(.is-revealed)').forEach(function (section) {
      if (isInZone(section)) revealSection(section);
      else sectionObserver.observe(section);
    });

    window.addEventListener('scroll', scanAll, { passive: true });
    window.addEventListener('resize', scanAll, { passive: true });

    initLenis();
    scanAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section && section.classList.contains('shopify-section')) {
      prepareSection(section);
      section.querySelectorAll('.nutrition-grid').forEach(function (grid) {
        if (isInZone(grid)) revealGrid(grid);
        else if (gridObserver) gridObserver.observe(grid);
      });
      if (isInZone(section)) revealSection(section);
      else if (sectionObserver) sectionObserver.observe(section);
    }
    scanAll();
  });
})();
